import { ArcType, Cartesian3, Color, Entity, HorizontalOrigin, LabelGraphics, LabelStyle, PolylineGraphics, } from "cesium";
const colour = Color.YELLOW.withAlpha(0.4);
export const createParallels = (showNumbers) => {
    const paralelList = [];
    for (let angle = -90 + 15; angle < 90; angle += 15) {
        const paralelLine = new Entity({
            id: "Parallel " + angle,
            name: "Parallel " + angle,
            polyline: new PolylineGraphics({
                positions: [
                    Cartesian3.fromDegrees(-180, angle, 0),
                    Cartesian3.fromDegrees(-90, angle, 0),
                    Cartesian3.fromDegrees(-0, angle, 0),
                    Cartesian3.fromDegrees(90, angle, 0),
                    Cartesian3.fromDegrees(180, angle, 0),
                ],
                width: 1,
                arcType: ArcType.RHUMB,
                material: colour,
            }),
        });
        paralelList.push(paralelLine);
        if (showNumbers) {
            const paralelNumber = new Entity({
                id: "Parallel number " + angle,
                name: "Parallel number " + angle,
                position: Cartesian3.fromDegrees(0, angle),
                label: new LabelGraphics({
                    fillColor: Color.WHITE,
                    font: "12pt Lucida Console",
                    horizontalOrigin: HorizontalOrigin.LEFT,
                    style: LabelStyle.FILL,
                    text: Math.abs(angle) + (angle < 0 ? "S" : "N"),
                }),
            });
            paralelList.push(paralelNumber);
        }
    }
    return paralelList;
};
export const createMeridians = (showNumbers) => {
    const meridiansList = [];
    for (let angle = 0; angle < 360; angle += 15) {
        const meridianLine = new Entity({
            id: "Meridian " + angle,
            name: "Meridian " + angle,
            polyline: new PolylineGraphics({
                positions: [
                    Cartesian3.fromDegrees(angle, 90, 0),
                    Cartesian3.fromDegrees(angle, 0, 0),
                    Cartesian3.fromDegrees(angle, -90, 0),
                ],
                width: 1,
                arcType: ArcType.RHUMB,
                material: colour,
            }),
        });
        meridiansList.push(meridianLine);
        if (showNumbers) {
            const meridianNumber = new Entity({
                id: "Meridian number " + angle,
                name: "Meridian number " + angle,
                position: Cartesian3.fromDegrees(angle, 0),
                label: new LabelGraphics({
                    fillColor: Color.WHITE,
                    font: "12pt Lucida Console",
                    horizontalOrigin: HorizontalOrigin.RIGHT,
                    style: LabelStyle.FILL,
                    text: (angle < 180 ? angle : 360 - angle) + (angle < 180 ? "E" : "W"),
                }),
            });
            meridiansList.push(meridianNumber);
        }
    }
    return meridiansList;
};
//# sourceMappingURL=meridiansParallels.js.map